export default __webpack_public_path__ + "static/media/icon-menu-green.9326f097.svg";